export enum RailTrackEnum {
  Back,
  Middle,
  Front
}
